@if (commentMode.offered()) {
  <!-- The tooltip sits on the wrapper: a disabled button takes no pointer events, and the reason it
   is disabled is what the tooltip says. -->
  <span
    [pTooltip]="tooltip()"
    class="inline-flex"
    tooltipPosition="bottom"
  >
    <button
      [attr.aria-pressed]="commentMode.on()"
      [disabled]="!commentMode.on() && !commentMode.canTurnOn()"
      (click)="commentMode.toggle()"
      class="flx-ds comment-mode-toggle"
      flxButton
      icon="left"
      type="button"
      data-testId="comment-mode-toggle"
    >
      <i
        class="ph ph-chat-circle"
        flxIcon
        aria-hidden="true"
      ></i>
      Comment
    </button>
  </span>
}
